export default "/_next/static/images/e5ebde1ec8ff9d1a7b36e73ddf9f03b1.jpg";